import { usePresenter } from "./context";

/** Superscript footnote numbers after a lead. */
export function Sup({ refs }: { refs: string[] }) {
  const { model } = usePresenter();
  const nums = refs.map((r) => model.refNumber.get(r)).filter((n): n is number => n !== undefined);
  if (!nums.length) return null;
  return <sup className="fn-sup">{nums.join(", ")}</sup>;
}

/** "[1] Yao et al., ReAct: …, 2023" rows at the foot of a slide. Click jumps to Read more. */
export function Footnotes({ refs, left = 64 }: { refs: string[]; left?: number }) {
  const { model, gotoReferences } = usePresenter();
  const items = refs.flatMap((id) => {
    const r = model.refs.get(id);
    const n = model.refNumber.get(id);
    return r && n ? [{ r, n }] : [];
  });
  if (!items.length) return null;
  return (
    <div
      className="abs footnotes"
      data-count={items.length > 1 ? "many" : "one"}
      style={{ left, width: 1216 - left }}
    >
      {items.map(({ r, n }) => {
        const full = [r.authors, r.title, r.year].filter(Boolean).join(", ");
        return (
          <button key={r.id} type="button" className="footnote" onClick={gotoReferences} title={full}>
            <span className="footnote-num">[{n}]</span>
            <span className="footnote-text">
              {r.authors ? `${r.authors} · ` : ""}
              <i>{r.title}</i>
            </span>
            {/* Outside the ellipsis: a long title is cut, never the year. */}
            {r.year && <span className="footnote-year">· {r.year}</span>}
          </button>
        );
      })}
    </div>
  );
}
